<template>
  <div class="bg-white border border-dull rounded">
    <slot />
  </div>
</template>

<script>

export default {
  name: 'ExpansionPanelGroup',

  props: { 
    value: String
  },

  reactiveProvide: {
    name: 'ExpansionPanelGroup',
    include: [
      'expanded',
      'expand'
    ]
  },

  methods: {
    expand (name) {
      if (name === this.value) {
        /*
         * it seems that if this value is not being set to also a String but a falsy
         * value like null or undefined, the vue observable system does not pick up on
         * it meaning that setting this 'value' prop to one of the aformentioned values
         * does not trigger prop-updates nor does it trigger watchers in this component
         * hence an arbitrary String is used here to represent the fact that no expansion
         * panel should currently be selected
         *
         * the preferred implementation would be nullifying this value but I couldn't figure
         * out how to still trigger the updates here
         */
        this.$emit('change', 'EXPANSION_PANEL_GROUP_NO_SELECTION')
      } else {
        this.$emit('change', name)
      }
    }
  },

  computed: {
    expanded () {
      return this.value
    }
  }
}

</script>
